(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  function setupSection(section) {
    if (section.hasAttribute('data-et-usp-init')) return;
    section.setAttribute('data-et-usp-init', '');

    var el = section.querySelector('.et-usp__swiper');
    if (!el) return;
    var dots = section.querySelector('.et-usp__dots');
    var instance = null;

    function update() {
      if (mq.matches && !instance) {
        instance = new Swiper(el, {
          slidesPerView: 1,
          spaceBetween: 16,
          pagination: dots ? { el: dots, clickable: true } : undefined
        });
      } else if (!mq.matches && instance) {
        instance.destroy(true, true);
        instance = null;
      }
    }

    if (mq.addEventListener) {
      mq.addEventListener('change', update);
    } else if (mq.addListener) {
      mq.addListener(update);
    }
    update();
  }

  function initAll(root) {
    whenSwiperReady(function () {
      (root || document).querySelectorAll('.et-usp').forEach(setupSection);
    });
  }

  function whenSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (attempts > 100) {
        clearInterval(timer);
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList && event.target.classList.contains('et-usp')) {
      whenSwiperReady(function () {
        setupSection(event.target);
      });
    } else if (event.target.querySelector('.et-usp')) {
      initAll(event.target);
    }
  });
})();
